const RECOMMENDED_COMMITTEE = 'Comitê de Proteção e Privacidade de Dados'

const ACTIVE_STATUS = 'active'
const INACTIVE_STATUS = 'inactive'

const STATUSES = {
  [ACTIVE_STATUS]: 'ATIVO',
  [INACTIVE_STATUS]: 'INATIVO',
}

const ACTIVE_STATUS_LABEL = 'Ativar'
const INACTIVE_STATUS_LABEL = 'Inativar'

const FORM_RECOMMENDED_COMMITTEE = 'formRecommendedCommittee'
const FORM_OTHER_COMMITTEE = 'formOtherCommitte'

const ANOTHER_COMMITTEE_CATEGORY_VALUE = 'another'

const COMMITTEES_MAIN_DRIVER_STEP_0 = 'committees-main-driver-step-0'

const COMMITTEES_MAIN_DRIVER_STEPS_OBJECT = [
  {
    element: '#' + COMMITTEES_MAIN_DRIVER_STEP_0,
    popover: {
      description:
        'Cadastre todos os <strong>comitês</strong> da sua instituição na tela <strong>Cadastrar Comitê</strong>. Ao fazer o cadastro de um novo comitê, será possível <strong>adicionar membros</strong> a ele. É <strong>fundamental</strong> que todos os membros estejam cadastrados e que o <strong>cargo</strong> de cada um seja definido dentro do comitê.</br></br> Caso não encontre a opção do cargo desejado, basta clicar na opção abaixo do campo de <strong>cargo</strong> no comitê para <strong>adicionar uma nova função</strong>.',
    },
  },
]

export default {
  ACTIVE_STATUS,
  ACTIVE_STATUS_LABEL,
  ANOTHER_COMMITTEE_CATEGORY_VALUE,
  COMMITTEES_MAIN_DRIVER_STEP_0,
  COMMITTEES_MAIN_DRIVER_STEPS_OBJECT,
  FORM_RECOMMENDED_COMMITTEE,
  FORM_OTHER_COMMITTEE,
  INACTIVE_STATUS_LABEL,
  RECOMMENDED_COMMITTEE,
  STATUSES,
}
